<script>
  export default{
    name:'BroadcastIcon'
  }
</script>
<template>
  <g>
    <defs>
      <linearGradient id="grad1" x1="0%" y1="0%" x2="100%" y2="0%">
        <stop offset="0%" style="stop-color:#f83600;stop-opacity:1" />
        <stop offset="100%" style="stop-color:#fe8c00;stop-opacity:1" />
      </linearGradient>
    </defs>
    <g>
      <path fill="url(#grad1)" d="M42.57,17.18c-0.27-0.19-0.61-0.23-0.92-0.11l-6.69,2.51C34.75,18.12,33.51,17,32,17H8c-1.65,0-3,1.35-3,3v12   c0,1.65,1.35,3,3,3h24c1.51,0,2.75-1.12,2.96-2.57l6.69,2.51C41.76,34.98,41.88,35,42,35c0.2,0,0.4-0.06,0.57-0.18   C42.84,34.63,43,34.33,43,34V18C43,17.67,42.84,17.37,42.57,17.18z M33,32c0,0.55-0.45,1-1,1H8c-0.55,0-1-0.45-1-1V20   c0-0.55,0.45-1,1-1h24c0.55,0,1,0.45,1,1v1v10V32z M41,32.56l-6-2.25v-8.61l6-2.25V32.56z"></path>
      <path fill="url(#grad1)" d="M30,21h-2c-0.55,0-1,0.45-1,1s0.45,1,1,1h2c0.55,0,1-0.45,1-1S30.55,21,30,21z" ></path>
    </g>
  </g>

</template>
